// Müşteri detay sayfası
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { 
  FiEdit, 
  FiPhone, 
  FiMail, 
  FiMapPin,
  FiUser,
  FiUsers,
  FiCalendar,
  FiFileText,
  FiTrash2,
  FiInfo,
  FiX,
  FiPlus,
  FiSettings,
  FiType,
  FiTrendingUp,
  FiEye
} from 'react-icons/fi';
import { CiCalendar } from 'react-icons/ci';
import { CgMenuGridO } from 'react-icons/cg';
import { IoChevronBackOutline } from 'react-icons/io5';
import { customerService } from '../../services/customerService';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../../components/Common/LoadingSpinner';
import toast from 'react-hot-toast';
import DeleteConfirmModal from '../../components/Common/DeleteConfirmModal';
import CustomerContactModal from '../../components/Customers/CustomerContactModal';
import CustomerMeetingModal from '../../components/Customers/CustomerMeetingModal';
import CustomerModal from '../../components/Customers/CustomerModal';
import CustomerNoteModal from '../../components/Customers/CustomerNoteModal';
import ProjectModal from '../../components/Projects/ProjectModal';
import CurrencyInput from 'react-currency-input-field';
import { formatDateTime, formatDateOnly, formatTimeOnly } from '../../utils/dateUtils';

const CustomerDetail = () => {
  const { id } = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { user: currentUser } = useAuth();
  const [showContactModal, setShowContactModal] = useState(false);
  const [editingContact, setEditingContact] = useState(null);
  const [editingOffer, setEditingOffer] = useState(null);
  const [showActionMenu, setShowActionMenu] = useState(false);
  const [offerProfitability, setOfferProfitability] = useState('');
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [showContactNoteModal, setShowContactNoteModal] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [contactNote, setContactNote] = useState('');
  const [showMeetingModal, setShowMeetingModal] = useState(false);
  const [editingMeeting, setEditingMeeting] = useState(null);
  const [showOfferModal, setShowOfferModal] = useState(false);
  const [offerStatus, setOfferStatus] = useState('Hazırlandı');
  const [offerTotal, setOfferTotal] = useState('');
  const [offerCurrency, setOfferCurrency] = useState('TRY');
  const [offerDescription, setOfferDescription] = useState('');
  const [offerFile, setOfferFile] = useState(null);
  const [uploadMessage, setUploadMessage] = useState('');
  const [uploadMessageType, setUploadMessageType] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedMeeting, setSelectedMeeting] = useState(null);
  const [newStatus, setNewStatus] = useState('');
  const [statusDescription, setStatusDescription] = useState('');
  const [editingNote, setEditingNote] = useState(null);
  const [profitability, setProfitability] = useState('');
  const [offerDate, setOfferDate] = useState('');
  const [offerTime, setOfferTime] = useState('');
  const [offerStatusModal, setOfferStatusModal] = useState({ visible: false, offerId: null, status: 'Hazırlandı' });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmData, setConfirmData] = useState({ type: null, id: null, title: '' });
  const [showMeetingDetailModal, setShowMeetingDetailModal] = useState(false);
  const [selectedMeetingDetail, setSelectedMeetingDetail] = useState(null);

  // Backend origin (dosya linkleri için tam URL)
  const API_ORIGIN = process.env.REACT_APP_API_URL || 'https://crm.apro.com.tr/api';

  // Teklif durumuna göre rozet sınıfları
  const getOfferStatusClass = (status) => {
    const base = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';
    switch ((status || '').toLowerCase()) {
      case 'hazırlandı':
        return `${base} bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200`;
      case 'gönderildi':
        return `${base} bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200`;
      case 'müşteri onay sürecinde':
        return `${base} bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200`;
      case 'müşteri revize istedi':
        return `${base} bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200`;
      case 'teklif kabul edilmedi':
        return `${base} bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200`;
      case 'teklif onaylandı':
        return `${base} bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200`;
      case 'revize gönderilecek':
        return `${base} bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200`;
      default:
        return `${base} bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200`;
    }
  };

  // Teklif gönderme fonksiyonu
  const handleOfferSubmit = async () => {

    setIsUploading(true);
    setUploadMessage('');
    setUploadMessageType('');

    try {
      const formData = new FormData();
        formData.append('offer_file', offerFile);
        formData.append('offer_status', offerStatus);
        formData.append('offer_total', offerTotal);
        formData.append('currency', offerCurrency);
        formData.append('profitability', offerProfitability);
        formData.append('offer_file_description', offerDescription);
        formData.append('offer_type', 'customer'); // Görev 2: Müşteri teklifi için 'customer'
        
        // Tarih ve saat birleştirme
        const combinedDateTime = offerDate && offerTime ? `${offerDate}T${offerTime}:00` : new Date().toISOString();
        formData.append('created_at', combinedDateTime);

      await customerService.createCustomerOffer(id, formData);
      
      toast.success('Teklif başarıyla eklendi');
      setShowOfferModal(false);
        setOfferFile(null);
        setOfferTotal('');
        setProfitability('');
        setOfferDescription('');
        setOfferStatus('Hazırlandı');
        setOfferCurrency('TRY');
        setOfferDate('');
        setOfferTime('');
      queryClient.invalidateQueries(['customer-offers', id]);
    } catch (error) {
      const msg = error.response?.data?.message || 'Teklif kaydedilemedi';
      toast.error(msg);
      setUploadMessage(msg);
      setUploadMessageType('error');
    } finally {
      setIsUploading(false);
    }
  };

  // Teklif güncelleme fonksiyonu
  const handleUpdateOffer = async () => {
    if (!editingOffer) return;
    
    setIsUploading(true);
    setUploadMessage('');
    setUploadMessageType('');

    try {
      const formData = new FormData();
      formData.append('offer_file_description', offerDescription);
      formData.append('offer_total', offerTotal);
      formData.append('profitability', offerProfitability);
      formData.append('currency', offerCurrency);
      formData.append('offer_status', offerStatus);
      
      // Tarih ve saat birleştirme
      const combinedDateTime = offerDate && offerTime ? `${offerDate}T${offerTime}:00` : new Date().toISOString();
      formData.append('created_at', combinedDateTime);
      
      if (offerFile) {
        formData.append('offer_file', offerFile);
      }

      await customerService.updateCustomerOffer(editingOffer.id, formData);
      toast.success('Teklif güncellendi');
      setShowOfferModal(false);
      setEditingOffer(null);
      setOfferDescription('');
      setOfferTotal('');
      setOfferProfitability('');
      setOfferCurrency('TRY');
      setOfferStatus('Hazırlandı');
      setOfferDate('');
      setOfferTime('');
      setOfferFile(null);
      queryClient.invalidateQueries(['customer-offers', id]);
    } catch (error) {
      const msg = error.response?.data?.message || 'Teklif güncellenemedi';
      toast.error(msg);
      setUploadMessage(msg);
      setUploadMessageType('error');
    } finally {
      setIsUploading(false);
    }
  };

  // Müşteri detaylarını al
  const { data: customerData, isLoading } = useQuery(
    ['customer', id],
    () => customerService.getCustomer(id),
    { enabled: !!id }
  );

  // Müşteri toplantılarını al
  const { data: meetingsData, isLoading: meetingsLoading } = useQuery(
    ['customer-meetings', id],
    () => customerService.getCustomerMeetings(id),
    { enabled: !!id }
  );

  // Müşteri tekliflerini al
  const { data: offersData, isLoading: offersLoading } = useQuery(
    ['customer-offers', id],
    () => customerService.getCustomerOffers(id),
    { enabled: !!id }
  );


  // Toplantı durumu güncelleme mutation'ı
  const updateMeetingStatusMutation = useMutation(
    ({ meetingId, status, description }) => 
      customerService.updateCustomerMeetingStatus(meetingId, { 
        meeting_status: status, 
        meeting_status_description: description 
      }),
    {
      onSuccess: () => {
        toast.success('Toplantı durumu güncellendi');
        queryClient.invalidateQueries(['customer-meetings', id]);
        setShowStatusModal(false);
        setSelectedMeeting(null);
        setNewStatus('');
        setStatusDescription('');
      },
      onError: (error) => {
        toast.error(error.response?.data?.message || 'Durum güncellenemedi');
      }
    }
  );

  // Kontak silme mutation'ı
  const deleteContactMutation = useMutation(
    ({ customerId, contactId }) => customerService.deleteContact(customerId, contactId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['customer', id]);
        toast.success('Kontak başarıyla silindi');
      },
      onError: (error) => {
        toast.error(error.response?.data?.message || 'Kontak silinemedi');
      }
    }
  );

  // Kontak notu güncelleme mutation'ı
  const updateContactNoteMutation = useMutation(
    ({ customerId, contactId, note }) => customerService.updateContactNote(customerId, contactId, note),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['customer', id]);
        toast.success('Kontak notu güncellendi');
        setShowContactNoteModal(false);
        setSelectedContact(null);
        setContactNote('');
      },
      onError: (error) => {
        toast.error(error.response?.data?.message || 'Not güncellenemedi');
      }
    }
  );

  if (isLoading) {
    return <LoadingSpinner text="Müşteri bilgileri yükleniyor..." fullScreen={false} />;
  }

  const customer = customerData?.customer;
  const contacts = customerData?.contacts || [];
  const projects = customerData?.projects || [];
  const meetings = meetingsData?.meetings || [];
  const notes = customerData?.notes || [];
  const offers = offersData?.offers || [];

  if (!customer) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500 dark:text-gray-400">Müşteri bulunamadı</p>
      </div>
    );
  }


  // Müşteri notları işlemleri
  const handleAddNote = () => {
    setEditingNote(null);
    setShowNoteModal(true);
  };

  const handleEditNote = (note) => {
    setEditingNote(note);
    setShowNoteModal(true);
  };

  const handleDeleteNote = (note) => {
    setConfirmData({ type: 'note', id: note.id, title: 'Bu notu silmek istediğinizden emin misiniz?' });
    setShowConfirmModal(true);
  };

  // Toplantı silme
  const handleDeleteMeeting = (meeting) => {
    setConfirmData({ type: 'meeting', id: meeting.id, title: 'Bu toplantıyı silmek istediğinizden emin misiniz?' });
    setShowConfirmModal(true);
  };

  // Toplantı detaylarını göster
  const handleShowMeetingDetail = (meeting) => {
    setSelectedMeetingDetail(meeting);
    setShowMeetingDetailModal(true);
  };

  // Toplantı detay modal'ını kapat
  const closeMeetingDetailModal = () => {
    setShowMeetingDetailModal(false);
    setSelectedMeetingDetail(null);
  };

  // Genel silme onayı işlemi
  const handleConfirmDelete = async () => {
    if (!confirmData?.type || !confirmData?.id) return;
    try {
      if (confirmData.type === 'note') {
        await customerService.deleteCustomerNote(confirmData.id);
        toast.success('Not silindi');
        queryClient.invalidateQueries(['customer', id]);
      } else if (confirmData.type === 'meeting') {
        await customerService.deleteCustomerMeeting(confirmData.id);
        toast.success('Toplantı silindi');
        queryClient.invalidateQueries(['customer-meetings', id]);
      } else if (confirmData.type === 'offer') {
        await customerService.deleteCustomerOffer(confirmData.id);
        toast.success('Teklif silindi');
        queryClient.invalidateQueries(['customer-offers', id]);
      }
    } catch (error) {
      toast.error('Silme işlemi başarısız');
    } finally {
      setShowConfirmModal(false);
      setConfirmData({ type: null, id: null, title: '' });
    }
  };

  // Kontak silme
  const handleDeleteContact = (contactId) => {
    if (window.confirm('Bu kontağı silmek istediğinizden emin misiniz?')) {
      deleteContactMutation.mutate({ customerId: id, contactId });
    }
  };

  // Kontak notu düzenleme
  const handleEditContactNote = (contact) => {
    setSelectedContact(contact);
    setContactNote(contact.note || '');
    setShowContactNoteModal(true);
  };

  // Not kaydetme
  const handleSaveNote = () => {
    if (selectedContact) {
      updateContactNoteMutation.mutate({
        customerId: id,
        contactId: selectedContact.id,
        note: contactNote
      });
    }
  };

  // Kontak notu silme
  const handleDeleteContactNote = (contact) => {
    if (window.confirm('Bu kontak notunu silmek istediğinizden emin misiniz?')) {
      updateContactNoteMutation.mutate({
        customerId: id,
        contactId: contact.id,
        note: ''
      });
    }
  };

  // Toplantı düzenle
  const handleEditMeeting = (meeting) => {
    setEditingMeeting(meeting);
    setShowMeetingModal(true);
  };

  // Durum değiştir
  const handleStatusChange = (meeting) => {
    setSelectedMeeting(meeting);
    setNewStatus(meeting.meeting_status);
    setStatusDescription(meeting.meeting_status_description || '');
    setShowStatusModal(true);
  };

  // Durum güncelle
  const handleUpdateStatus = () => {
    if (selectedMeeting && newStatus) {
      // İptal veya Ertelendi durumlarında açıklama zorunlu
      if ((newStatus === 'İptal' || newStatus === 'Ertelendi') && !statusDescription.trim()) {
        toast.error('İptal veya Ertelendi durumları için açıklama gereklidir');
        return;
      }
      
      // Planlandı veya Tamamlandı durumlarında açıklama alanını temizle
      let description = statusDescription;
      if (newStatus === 'Planlandı' || newStatus === 'Tamamlandı') {
        description = '';
      }
      
      updateMeetingStatusMutation.mutate({
        meetingId: selectedMeeting.id,
        status: newStatus,
        description: description
      });
    }
  };

  return (
    <div className="space-y-6">
      {/* Sayfa başlığı */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <button
            onClick={() => window.history.back()}
            className="flex items-center text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
            title="Geri"
          >
            <IoChevronBackOutline size={24} />
          </button>
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              {customer.customer_name}
            </h1>
      
          </div>
        </div>
        {/* Guest kullanıcılar hiçbir müşteriyi düzenleyemez */}
        {currentUser?.user_type !== 'guest' && (
          <div className="flex items-center space-x-3">
            {/* User kullanıcılar sadece kendi müşterilerini düzenleyebilir */}
            {!(currentUser?.user_type === 'user' && customer.customer_account_manager !== currentUser?.id) && (
              <div className="relative action-menu">
                <button 
                  onClick={() => setShowActionMenu((v) => !v)}
                  className="btn-primary flex items-center"
                >
                  <CgMenuGridO className="mr-2" size={16} />
                  İşlemler
                </button>
                {showActionMenu && (
                  <div className="absolute top-full right-0 mt-2 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md shadow-xl z-50 min-w-48">
                    <div className="py-1">
                      <button onClick={() => { setShowCustomerModal(true); setShowActionMenu(false); }} className="flex items-center w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700">
                        <FiEdit className="mr-3" size={16} /> Düzenle
                      </button>
                      <button onClick={() => { setEditingContact(null); setShowContactModal(true); setShowActionMenu(false); }} className="flex items-center w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700">
                        <FiUser className="mr-3" size={16} /> Yeni Kontak
                      </button>
                      {/* User kullanıcılar sadece kendi müşterileri için proje oluşturabilir */}
                      {!(currentUser?.user_type === 'user' && customer.customer_account_manager !== currentUser?.id) && (
                        <button onClick={() => { setShowProjectModal(true); setShowActionMenu(false); }} className="flex items-center w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700">
                          <FiFileText className="mr-3" size={16} /> Yeni Proje
                        </button>
                      )}
                      <button onClick={() => { setEditingMeeting(null); setShowMeetingModal(true); setShowActionMenu(false); }} className="flex items-center w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700">
                        <FiCalendar className="mr-3" size={16} /> Yeni Toplantı
                      </button>
                      <button onClick={() => { handleAddNote(); setShowActionMenu(false); }} className="flex items-center w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700">
                        <FiFileText className="mr-3" size={16} /> Not Ekle
                      </button>
                      {currentUser?.user_type !== 'guest' && (
                        <button onClick={() => { setShowOfferModal(true); setShowActionMenu(false); }} className="flex items-center w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700">
                          <FiTrendingUp className="mr-3" size={16} /> Teklif Ekle
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      <div className="space-y-6">
        {/* Müşteri Bilgileri, Kontaklar ve Projeler */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Müşteri Bilgileri */}
          <div className="lg:col-span-1 space-y-6">
            <div className="card p-0 overflow-hidden">
          <div className="bg-gray-50 dark:bg-gray-700 px-6 py-4 border-b border-gray-200 dark:border-gray-600">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              Müşteri Bilgileri
            </h3>
          </div>
          <div className="p-6">
          
          <div className="space-y-4">
            {/* Müşteri İsmi */}
            <div className="flex items-start space-x-3">
              <FiUser className="h-5 w-5 text-gray-400 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Müşteri İsmi
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  {customer.customer_name}
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <FiMapPin className="h-5 w-5 text-gray-400 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Adres
                </p>
                <p className={`text-sm ${customer.customer_address ? 'text-gray-500 dark:text-gray-400' : 'text-red-500 dark:text-red-400'}`}>
                  {customer.customer_address || 'Henüz adres bilgisi girilmemiş'}
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <FiPhone className="h-5 w-5 text-gray-400 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Telefon
                </p>
                <p className={`text-sm ${customer.customer_phone ? 'text-gray-500 dark:text-gray-400' : 'text-red-500 dark:text-red-400'}`}>
                  {customer.customer_phone || 'Henüz telefon bilgisi girilmemiş'}
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <FiUser className="h-5 w-5 text-gray-400 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Müşteri Temsilcisi
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  {customer.account_manager_name || 'Belirtilmemiş'}
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <FiCalendar className="h-5 w-5 text-gray-400 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Durum
                </p>
                <span className={customer.cutomer_status ? 'status-active' : 'status-inactive'}>
                  {customer.cutomer_status ? 'Aktif' : 'Pasif'}
                </span>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <FiCalendar className="h-5 w-5 text-gray-400 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Oluşturulma
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  {formatDateOnly(customer.created_at)}
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <FiUser className="h-5 w-5 text-gray-400 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Oluşturan
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  {customer.created_by || 'Bilinmiyor'}
                </p>
              </div>
            </div>
           </div>
           </div>
            </div>

            {/* Kontaklar */}
            <div className="card p-0 overflow-hidden">
              <div className="bg-gray-50 dark:bg-gray-700 px-6 py-4 border-b border-gray-200 dark:border-gray-600">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Kontaklar
                </h3>
              </div>
              <div className="p-6">
                {contacts.length > 0 ? (
                  <div className="space-y-3">
                    {contacts.map((contact) => (
                      <div key={contact.id} className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
                        <div className="flex items-center space-x-3">
                          <div className="h-10 w-10 bg-brand-primary rounded-full flex items-center justify-center">
                            <span className="text-white font-medium text-sm">
                              {contact.contact_fullname.charAt(0).toUpperCase()}
                            </span>
                          </div>
                          <div>
                            <p className="font-medium text-gray-900 dark:text-white">
                              {contact.contact_fullname}
                            </p>
                            <p className={`text-sm ${contact.contact_role ? 'text-gray-500 dark:text-gray-400' : 'text-red-500 dark:text-red-400'}`}>
                              {contact.contact_role || '-'}
                            </p>
                            <div className="flex items-center space-x-4 mt-1">
                              <span className={`text-xs flex items-center ${contact.contact_email ? 'text-gray-500 dark:text-gray-400' : 'text-red-500 dark:text-red-400'}`}>
                                <FiMail className="mr-1" size={12} />
                                {contact.contact_email || '-'}
                              </span>
                              <span className={`text-xs flex items-center ${contact.contact_gsm ? 'text-gray-500 dark:text-gray-400' : 'text-red-500 dark:text-red-400'}`}>
                                <FiPhone className="mr-1" size={12} />
                                {contact.contact_gsm || '-'}
                              </span>
                            </div>
                            {contact.note && (
                              <div className="mt-2 p-1 bg-red-500 rounded">
                                <div className="flex items-start justify-between">
                                  <div className="flex items-start space-x-2">
                                    <FiInfo className="text-white mt-0.5" size={14} />
                                    <span className="text-xs text-white">
                                      {contact.note}
                                    </span>
                                  </div>
                                  {currentUser?.user_type !== 'guest' && (
                                    <button
                                      onClick={() => handleDeleteContactNote(contact)}
                                      className="text-white hover:text-red-200 ml-2"
                                      title="Notu sil"
                                    >
                                      <FiX size={14} />
                                    </button>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        {/* Guest kullanıcılar için kontak işlem butonlarını gizle */}
                        {currentUser?.user_type !== 'guest' && (
                          <div className="flex items-center space-x-2">
                            <button
                              onClick={() => handleEditContactNote(contact)}
                              className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                              title="Not Ekle/Düzenle"
                            >
                              <FiInfo size={16} />
                            </button>
                            <button
                              onClick={() => {
                                setEditingContact(contact);
                                setShowContactModal(true);
                              }}
                              className="text-yellow-600 hover:text-yellow-800 dark:text-yellow-400 dark:hover:text-yellow-300"
                              title="Düzenle"
                            >
                              <FiEdit size={16} />
                            </button>
                            <button
                              onClick={() => handleDeleteContact(contact.id)}
                              className="text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300"
                              title="Sil"
                            >
                              <FiTrash2 size={16} />
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-8">
                    <FiUser className="mx-auto h-12 w-12 text-gray-400" />
                    <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                      Henüz kontak eklenmemiş
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Müşteri Toplantıları */}
          <div className="lg:col-span-2 space-y-6">
            <div className="bg-gradient-to-br from-indigo-50 to-purple-50 dark:from-gray-800 dark:to-gray-700 rounded-xl p-6 border border-indigo-100 dark:border-gray-600 transition-all duration-300">
              <div className="flex items-center space-x-3 mb-6">
                <div className="flex items-center justify-center w-10 h-10 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-xl shadow-md">
                  <FiCalendar className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                    Müşteri Toplantıları
                  </h3>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    {meetingsData?.meetings?.length > 0 ? `${meetingsData.meetings.length} toplantı planlandı` : 'Toplantı yok'}
                  </p>
                </div>
              </div>
              {meetingsLoading ? (
                <div className="flex items-center justify-center py-8">
                  <div className="flex items-center space-x-3">
                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-indigo-500"></div>
                    <span className="text-sm text-gray-600 dark:text-gray-400">Toplantılar yükleniyor...</span>
                  </div>
                </div>
                ) : meetingsData?.meetings?.length > 0 ? (
                  <div className="space-y-3">
                    {meetingsData.meetings.map((meeting) => {
                      const meetingDate = new Date(meeting.meeting_start_date);
                      const isToday = meetingDate.toDateString() === new Date().toDateString();
                      const isTomorrow = meetingDate.toDateString() === new Date(Date.now() + 86400000).toDateString();
                      
                      return (
                        <div
                          key={meeting.id}
                          onClick={() => handleShowMeetingDetail(meeting)}
                        className="group relative bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-100 dark:border-gray-600 hover:border-indigo-200 dark:hover:border-indigo-500 transition-all duration-300 hover:shadow-md transform hover:scale-[1.02] cursor-pointer"
                      >
                        <div className="flex items-start space-x-3">
                            {/* Sol taraf - Zaman */}
                            <div className="flex-shrink-0 text-center">
                              <div className="bg-gradient-to-br from-indigo-100 to-purple-100 dark:from-indigo-900 dark:to-purple-900 rounded-lg p-5 min-w-[110px]">
                                <div className="text-lg font-bold text-indigo-600 dark:text-indigo-400">
                                  {formatDateOnly(meeting.meeting_start_date)}
                                </div>
                                <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                  {formatTimeOnly(meeting.meeting_start_date)}
                                </div>
                              </div>
                              
                              {/* Toplantı Lokasyonu - Sol kutunun altına */}
                              {meeting.meeting_location && (
                                <div className="flex items-center justify-center space-x-1 mt-2">
                                  <FiMapPin className="w-3 h-3 text-gray-400" />
                                  <span className="text-xs text-gray-500 dark:text-gray-400 text-center">
                                    {meeting.meeting_location}
                                  </span>
                                </div>
                              )}
                            </div>

                            {/* Orta - İçerik */}
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center space-x-2 mb-2">
                                <h4 className="text-sm font-bold text-gray-900 dark:text-white">
                                  {meeting.meeting_subject}
                                </h4>
                                <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                  meeting.meeting_type === 'Online' 
                                    ? 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300'
                                    : 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300'
                                }`}>
                                  {meeting.meeting_type}
                                </span>
                                <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                  meeting.meeting_status === 'Tamamlandı' ? 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300' :
                                  meeting.meeting_status === 'Planlandı' ? 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900 dark:text-yellow-300' :
                                  'bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-300'
                                }`}>
                                  {meeting.meeting_status}
                                </span>
                              </div>
                              
                              <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">
                                {meeting.meeting_description}
                              </p>
                              
                              {/* Toplantıyı Yaratan */}
                              <div className="flex items-center space-x-1 mb-2">
                                <FiUser className="w-3 h-3 text-gray-400" />
                                <span className="text-xs text-gray-500 dark:text-gray-400">
                                  Yaratan: {meeting.created_by_name || 'Belirtilmemiş'}
                                </span>
                              </div>
                              {/* Katılımcılar - En alta taşındı */}
                              <div className="flex items-center space-x-1 mt-2">
                                <FiUsers className="w-3 h-3 text-gray-400" />
                                <span className="text-xs text-gray-500 dark:text-gray-400">
                                  Katılımcılar: 
                                </span>
                                {meeting.meeting_participation ? (() => {
                                  try {
                                    const participants = JSON.parse(meeting.meeting_participation);
                                    return participants.length > 0 ? (
                                      <div className="flex flex-wrap gap-1">
                                        {participants.slice(0, 3).map((participant, index) => (
                                          <span 
                                            key={index}
                                            className="inline-flex items-center px-2 py-0.5 rounded-full bg-blue-100 text-blue-800 text-xs font-medium"
                                          >
                                            {participant.user_fullname}
                                          </span>
                                        ))}
                                        {participants.length > 3 && (
                                          <span className="text-xs text-gray-500 dark:text-gray-400">
                                            +{participants.length - 3} daha
                                          </span>
                                        )}
                                      </div>
                                    ) : (
                                      <span className="text-xs text-red-500 dark:text-red-400">
                                        Katılımcı eklenmemiştir
                                      </span>
                                    );
                                  } catch (error) {
                                    return (
                                      <span className="text-xs text-red-500 dark:text-red-400">
                                        Katılımcı eklenmemiştir
                                      </span>
                                    );
                                  }
                                })() : (
                                  <span className="text-xs text-red-500 dark:text-red-400">
                                    Katılımcı eklenmemiştir
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          
                          {/* Guest kullanıcılar için toplantı işlem butonlarını gizle */}
                          {currentUser?.user_type !== 'guest' && meeting.created_by == currentUser?.id && (
                            <div className="absolute top-4 right-4 flex items-center space-x-2 opacity-0 group-hover:opacity-100 transition-opacity">
                              {meeting.meeting_status === 'Planlandı' && (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditMeeting(meeting);
                                  }}
                                  className="text-yellow-600 hover:text-yellow-800 dark:text-yellow-400 dark:hover:text-yellow-300"
                                  title="Düzenle"
                                >
                                  <FiEdit size={16} />
                                </button>
                              )}
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleStatusChange(meeting);
                                }}
                                className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                                title="Durum Değiştir"
                              >
                                <FiSettings size={16} />
                              </button>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeleteMeeting(meeting);
                                }}
                                className="text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300"
                                title="Sil"
                              >
                                <FiTrash2 size={16} />
                              </button>
                            </div>
                          )}
                      </div>
                    );
                  })}
                  </div>
                ) : (
                  <div className="text-center py-12">
                    <div className="flex flex-col items-center space-y-4">
                      <div className="w-16 h-16 bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-600 rounded-full flex items-center justify-center">
                        <FiCalendar className="w-8 h-8 text-gray-400" />
                      </div>
                      <div>
                        <p className="text-gray-500 dark:text-gray-400 font-medium">
                          Henüz toplantı eklenmemiş
                        </p>
                        <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
                          Yeni toplantılar eklendiğinde burada görünecek
                        </p>
                      </div>
                    </div>
                  </div>
                )}
            </div>

          {/* Projeler */}
          <div className="card p-0 overflow-hidden">
            <div className="bg-gray-50 dark:bg-gray-700 px-6 py-4 border-b border-gray-200 dark:border-gray-600">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                Projeler
              </h3>
            </div>
            <div className="p-6">
              {projects.length > 0 ? (
                <div className="space-y-3">
                  {projects.map((project) => (
                    <div
                      key={project.id}
                      className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700 rounded-lg cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600"
                      onClick={() => navigate(`/projects/${project.project_uuid}`)}
                    >
                      <div className="flex items-center space-x-3">
                        <div className="h-10 w-10 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center">
                          <FiFileText className="h-5 w-5 text-blue-600 dark:text-blue-400" />
                        </div>
                        <div>
                          <p className="text-sm font-medium text-gray-900 dark:text-white">
                            {project.project_name}
                          </p>
                          <p className="text-sm text-gray-500 dark:text-gray-400">
                            {project.project_status}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        <span className={`px-2 py-1 text-xs rounded-full ${
                          project.project_status === 'Aktif' 
                            ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300'
                            : 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300'
                        }`}>
                          {project.project_status}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-8">
                  <FiFileText className="mx-auto h-12 w-12 text-gray-400" />
                  <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                    Henüz proje eklenmemiş
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Teklifler */}
          <div className="card p-0 overflow-hidden">
            <div className="bg-gray-50 dark:bg-gray-700 px-6 py-4 border-b border-gray-200 dark:border-gray-600">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Teklifler</h3>
              </div>
            </div>
            <div className="p-6">
              {offers.length > 0 ? (
                <div className="space-y-3">
                  {offers.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).map((offer) => (
                    <div key={offer.id} className="flex items-center justify-between p-4 bg-gradient-to-r from-indigo-50 to-purple-50 dark:from-gray-800 dark:to-gray-700 rounded-lg">
                      <div className="flex items-center space-x-3">
                        <div className="h-12 w-12 bg-gradient-to-br from-blue-500 to-purple-600 dark:from-blue-600 dark:to-purple-700 rounded-xl flex items-center justify-center shadow-lg">
                          <FiFileText className="h-6 w-6 text-white" />
                        </div>
                        <div>
                          <p className="font-medium text-gray-900 dark:text-white">
                            Teklif #{offer.id}
                          </p>
                          <p className="text-sm text-gray-500 dark:text-gray-400">
                            {offer.offer_file_description || ''}
                          </p>
                          <div className="mt-1">
                            <span className={getOfferStatusClass(offer.offer_status)}>
                              {offer.offer_status}
                            </span>
                            
                            {/* Tüm durumlarda detaylı bilgileri göster */}
                            <div className="mt-2 flex flex-wrap items-center gap-3 text-xs text-gray-600 dark:text-gray-300">
                              <span className="inline-flex items-center rounded-md bg-white/50 dark:bg-gray-800/50 px-2 py-0.5">
                                <span className="mr-1 opacity-70">Tutar:</span>
                                <strong>
                                  {new Intl.NumberFormat('tr-TR', { style: 'currency', currency: (offer.currency || 'TRY') === 'USD' ? 'USD' : 'TRY' }).format(Number(offer.offer_total || 0))}
                                </strong>
                              </span>
                              <span className="inline-flex items-center rounded-md bg-white/50 dark:bg-gray-800/50 px-2 py-0.5">
                                <span className="mr-1 opacity-70">Kârlılık:</span>
                                <strong>
                                  {new Intl.NumberFormat('tr-TR', { style: 'currency', currency: (offer.currency || 'TRY') === 'USD' ? 'USD' : 'TRY' }).format(Number(offer.profitability || 0))}
                                </strong>
                              </span>
                              {Number(offer.offer_total) > 0 && (
                                <span className="inline-flex items-center rounded-md bg-white/50 dark:bg-gray-800/50 px-2 py-0.5">
                                  <span className="mr-1 opacity-70">Kârlılık Oranı:</span>
                                  <strong>
                                    {((Number(offer.profitability || 0) / Number(offer.offer_total)) * 100).toFixed(2)}%
                                  </strong>
                                </span>
                              )}
                              {offer.currency && (
                                <span className="inline-flex items-center rounded-md bg-white/50 dark:bg-gray-800/50 px-2 py-0.5">
                                  <span className="mr-1 opacity-70">Para Birimi:</span>
                                  <strong>{offer.currency}</strong>
                                </span>
                              )}
                              {offer.created_at && (
                                <span className="inline-flex items-center rounded-md bg-white/50 dark:bg-gray-800/50 px-2 py-0.5">
                                  <span className="mr-1 opacity-70">Gönderilme:</span>
                                  <strong>{(() => {
                                    // Veritabanından gelen tarihi direkt format et
                                    const dateStr = offer.created_at;
                                    if (dateStr.includes('T')) {
                                      // ISO format ise
                                      const [date, time] = dateStr.split('T');
                                      const [year, month, day] = date.split('-');
                                      const [hour, minute] = time.split(':');
                                      return `${day}.${month}.${year} ${hour}:${minute}`;
                                    } else {
                                      // MySQL DATETIME format ise
                                      const [date, time] = dateStr.split(' ');
                                      const [year, month, day] = date.split('-');
                                      const [hour, minute] = time.split(':');
                                      return `${day}.${month}.${year} ${hour}:${minute}`;
                                    }
                                  })()}</strong>
                                </span>
                              )}
                              {/* Dosya durumu */}
                              {(!offer.offer_file_path || offer.offer_file_path.trim() === '') ? (
                                <span className="inline-flex items-center rounded-md bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 px-2 py-0.5 text-amber-600 dark:text-amber-400">
                                  <FiFileText className="mr-1 h-3 w-3" />
                                  <span className="opacity-70">Dosya eklenmemiştir</span>
                                </span>
                              ) : (
                                <span className="inline-flex items-center rounded-md bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 px-2 py-0.5 text-green-600 dark:text-green-400">
                                  <button
                                    onClick={async () => {
                                      try {
                                        const response = await customerService.downloadCustomerOfferFile(offer.id);
                                        // Dosya indirme işlemi
                                        const url = window.URL.createObjectURL(new Blob([response.data]));
                                        const link = document.createElement('a');
                                        link.href = url;
                                        link.setAttribute('download', offer.offer_file_name || 'teklif.pdf');
                                        document.body.appendChild(link);
                                        link.click();
                                        link.remove();
                                        window.URL.revokeObjectURL(url);
                                      } catch (error) {
                                        toast.error('Dosya indirilemedi');
                                      }
                                    }}
                                    className="flex items-center hover:bg-green-200 dark:hover:bg-green-800 rounded px-1 py-0.5 mr-1"
                                    title="Dosyayı indir"
                                  >
                                    <FiFileText className="mr-1 h-3 w-3" />
                                    <span className="opacity-70">{offer.offer_file_name || 'Dosya'}</span>
                                  </button>
                                  <button
                                    onClick={async () => {
                                      if (window.confirm('Dosyayı silmek istediğinizden emin misiniz?')) {
                                        try {
                                          await customerService.deleteCustomerOfferFile(offer.id);
                                          toast.success('Dosya silindi');
                                          queryClient.invalidateQueries(['customer-offers', id]);
                                        } catch (error) {
                                          toast.error('Dosya silinemedi');
                                        }
                                      }
                                    }}
                                    className="hover:bg-green-200 dark:hover:bg-green-800 rounded-full p-0.5"
                                    title="Dosyayı sil"
                                  >
                                    <FiX className="h-3 w-3" />
                                  </button>
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        {offer.offer_file_path && offer.offer_file_path.trim() !== '' && (
                          <a
                            href={`${API_ORIGIN}${offer.offer_file_path}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                            title="Görüntüle/İndir"
                            download
                          >
                            <FiEye size={16} />
                          </a>
                        )}
                        {currentUser?.user_type !== 'guest' && (
                          <button
                            onClick={() => {
                              setEditingOffer(offer);
                              setOfferDescription(offer.offer_file_description || '');
                              setOfferTotal(offer.offer_total || '');
                              setOfferProfitability(offer.profitability || '');
                              setOfferCurrency(offer.currency || 'TRY');
                              setOfferStatus(offer.offer_status || 'Hazırlandı');
                              setOfferDate(offer.created_at ? offer.created_at.split('T')[0] : '');
                              setOfferTime(offer.created_at ? offer.created_at.split('T')[1]?.substring(0, 5) : '');
                              setShowOfferModal(true);
                            }}
                            className="text-green-600 hover:text-green-800 dark:text-green-400 dark:hover:text-green-300"
                            title="Düzenle"
                          >
                            <FiEdit size={16} />
                          </button>
                        )}
                        {currentUser?.user_type !== 'guest' && (
                          <button
                            onClick={() => setOfferStatusModal({ visible: true, offerId: offer.id, status: offer.offer_status })}
                            className="text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200"
                            title="Durum Değiştir"
                          >
                            <FiSettings size={16} />
                          </button>
                        )}
                        {currentUser?.user_type !== 'guest' && (
                          <button
                            onClick={() => {
                              setConfirmData({ type: 'offer', id: offer.id, title: 'Bu teklifi silmek istediğinizden emin misiniz?' });
                              setShowConfirmModal(true);
                            }}
                            className="text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-200"
                            title="Sil"
                          >
                            <FiTrash2 size={16} />
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-8">
                  <FiFileText className="mx-auto h-12 w-12 text-gray-400 dark:text-gray-500" />
                  <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-white">Teklif bulunamadı</h3>
                  <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">Bu müşteri için henüz teklif eklenmemiş.</p>
                </div>
              )}
            </div>
          </div>

          {/* Müşteri Notları */}
          <div className="card p-0 overflow-hidden">
            <div className="bg-gray-50 dark:bg-gray-700 px-6 py-4 border-b border-gray-200 dark:border-gray-600">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Müşteri Notları
                </h3>
              </div>
            </div>
            <div className="p-6">
              {notes.length > 0 ? (
                <div className="space-y-3">
                  {notes.map((note) => (
                    <div
                      key={note.id}
                      className="flex items-start justify-between p-4 bg-gray-50 dark:bg-gray-700 rounded-lg"
                    >
                      <div className="flex-1">
                        <div className="flex items-center space-x-3">
                          <div className="flex-shrink-0">
                            <div className="h-10 w-10 bg-purple-100 dark:bg-purple-900 rounded-full flex items-center justify-center">
                              <FiFileText className="h-5 w-5 text-purple-600 dark:text-purple-400" />
                            </div>
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center space-x-2">
                              <p className="text-sm font-medium text-gray-900 dark:text-white">
                                {note.note_type}
                              </p>
                              <span className="text-xs text-gray-500 dark:text-gray-400">
                                {formatDateOnly(note.created_at)}
                              </span>
                            </div>
                            <p className="text-sm text-gray-600 dark:text-gray-300 mt-1">
                              {note.customer_notes}
                            </p>
                            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                              {note.created_by}
                            </p>
                          </div>
                        </div>
                      </div>
                      {currentUser?.user_type !== 'guest' && (
                        <div className="flex items-center space-x-1">
                          <button
                            onClick={() => handleEditNote(note)}
                            className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                            title="Düzenle"
                          >
                            <FiEdit size={16} />
                          </button>
                          <button
                            onClick={() => handleDeleteNote(note)}
                            className="text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300"
                            title="Sil"
                          >
                            <FiTrash2 size={16} />
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-8">
                  <FiFileText className="mx-auto h-12 w-12 text-gray-400" />
                  <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                    Henüz not eklenmemiş
                  </p>
                </div>
              )}
            </div>
          </div>
          </div>
        </div>

      </div>

      {/* Kontak modal'ı */}
      {showContactModal && (
        <CustomerContactModal
          customerId={id}
          contact={editingContact}
          onClose={() => {
            setShowContactModal(false);
            setEditingContact(null);
          }}
          onSuccess={() => {
            setShowContactModal(false);
            setEditingContact(null);
            queryClient.invalidateQueries(['customer', id]);
          }}
        />
      )}

      {/* Müşteri düzenleme modal'ı */}
      {showCustomerModal && (
        <CustomerModal
          customer={customer}
          onClose={() => setShowCustomerModal(false)}
          onSuccess={() => {
            setShowCustomerModal(false);
            queryClient.invalidateQueries(['customer', id]);
          }}
        />
      )}

      {/* Proje ekleme modal'ı */}
      {showProjectModal && (
        <ProjectModal
          project={null}
          customer={customer}
          onClose={() => setShowProjectModal(false)}
          onSuccess={() => {
            setShowProjectModal(false);
            queryClient.invalidateQueries(['customer', id]);
          }}
        />
      )}

      {/* Müşteri notu modal'ı */}
      {showNoteModal && (
        <CustomerNoteModal
          customerId={id}
          note={editingNote}
          onClose={() => {
            setShowNoteModal(false);
            setEditingNote(null);
          }}
          onSuccess={() => {
            setShowNoteModal(false);
            setEditingNote(null);
            queryClient.invalidateQueries(['customer', id]);
          }}
        />
      )}


      {/* Kontak notu düzenleme modal'ı */}
      {showContactNoteModal && selectedContact && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-800 rounded-lg w-full max-w-md mx-4 overflow-hidden">
            {/* Modal başlığı */}
            <div className="bg-brand-primary text-white px-6 py-4">
              <h3 className="text-lg font-semibold">
                Kontak Notu
              </h3>
              <p className="text-sm text-gray-200 mt-1">
                {selectedContact.contact_fullname} için not ekleyin/düzenleyin
              </p>
            </div>
            
            {/* Modal içeriği */}
            <div className="p-6">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Not
                  </label>
                  <textarea
                    value={contactNote}
                    onChange={(e) => setContactNote(e.target.value)}
                    className="input-field"
                    rows={6}
                    placeholder="Kontak hakkında not yazın..."
                  />
                </div>
              </div>

              {/* Modal butonları */}
              <div className="flex space-x-3 mt-6">
                <button
                  onClick={handleSaveNote}
                  className="btn-primary flex-1"
                  disabled={updateContactNoteMutation.isLoading}
                >
                  {updateContactNoteMutation.isLoading ? 'Kaydediliyor...' : 'Kaydet'}
                </button>
                <button
                  onClick={() => {
                    setShowContactNoteModal(false);
                    setSelectedContact(null);
                    setContactNote('');
                  }}
                  className="btn-secondary flex-1"
                >
                  İptal
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Müşteri toplantı modal'ı */}
      {showMeetingModal && (
        <CustomerMeetingModal
          customerId={id}
          meeting={editingMeeting}
          onClose={() => {
            setShowMeetingModal(false);
            setEditingMeeting(null);
          }}
          onSuccess={() => {
            setShowMeetingModal(false);
            setEditingMeeting(null);
            queryClient.invalidateQueries(['customer-meetings', id]);
          }}
        />
      )}

      {/* Silme Onay Modal'ı */}
      {showConfirmModal && (
        <div className="modal-overlay">
          <div className="modal-content max-w-md">
            <div className="modal-header">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-medium text-white">Silme Onayı</h3>
                <button onClick={() => setShowConfirmModal(false)} className="text-white hover:text-gray-300">
                  <FiX size={20} />
                </button>
              </div>
            </div>
            <div className="p-6">
              <p className="text-sm text-gray-700 dark:text-gray-300">{confirmData.title || 'Bu öğeyi silmek istiyor musunuz?'}</p>
              <div className="flex items-center justify-end space-x-3 pt-6">
                <button onClick={() => setShowConfirmModal(false)} className="btn-secondary">İptal</button>
                <button onClick={handleConfirmDelete} className="btn-danger">Evet, Sil</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Toplantı Detay Modal'ı */}
      {showMeetingDetailModal && selectedMeetingDetail && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="modal-content max-w-2xl">
            <div className="modal-header">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-medium text-white">
                  Toplantı Detayları
                </h3>
                <button
                  onClick={closeMeetingDetailModal}
                  className="text-white hover:text-gray-300"
                >
                  <FiX size={20} />
                </button>
              </div>
            </div>
            
            <div className="p-6 space-y-4">
              {/* Toplantı Başlığı */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Toplantı Konusu
                </label>
                <p className="text-gray-900 dark:text-white font-medium">
                  {selectedMeetingDetail.meeting_subject}
                </p>
              </div>

              {/* Toplantı Amacı */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Toplantı Amacı
                </label>
                <div className="flex items-center space-x-2">
                  <FiCalendar className="h-4 w-4 text-purple-500" />
                  <span className="text-gray-900 dark:text-white font-medium">
                    {selectedMeetingDetail.meeting_reason || 'Belirtilmemiş'}
                  </span>
                </div>
              </div>


          
              {/* Tarih ve Saat */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Başlangıç
                  </label>
                  <div className="flex items-center space-x-2">
                    <CiCalendar className="h-4 w-4 text-gray-400" />
                    <span className="text-gray-900 dark:text-white">
                      {formatDateTime(selectedMeetingDetail.meeting_start_date)}
                    </span>
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Bitiş
                  </label>
                  <div className="flex items-center space-x-2">
                    <CiCalendar className="h-4 w-4 text-gray-400" />
                    <span className="text-gray-900 dark:text-white">
                      {formatDateTime(selectedMeetingDetail.meeting_end_date)}
                    </span>
                  </div>
                </div>
              </div>

              {/* Toplantı Tipi ve Konum */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Toplantı Tipi */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Toplantı Tipi
                  </label>
                  <div className="flex items-center space-x-2">
                    <FiType className="h-4 w-4 text-blue-500" />
                    <span className="text-gray-900 dark:text-white font-medium">
                      {selectedMeetingDetail.meeting_type || 'Belirtilmemiş'}
                    </span>
                  </div>
                </div>
          
                {/* Konum */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Toplantı Yeri
                  </label>
                  <div className="flex items-center space-x-2">
                    <FiMapPin className="h-4 w-4 text-green-500" />
                    <span className="text-gray-900 dark:text-white font-medium">
                      {selectedMeetingDetail.meeting_location || 'Belirtilmemiş'}
                    </span>
                  </div>
                </div>
              </div>

              {/* Açıklama */}
              {selectedMeetingDetail.meeting_description && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Açıklama
                  </label>
                  <p className="text-gray-900 dark:text-white text-sm">
                    {selectedMeetingDetail.meeting_description}
                  </p>
                </div>
              )}

              {/* Durum */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Durum
                </label>
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                  selectedMeetingDetail.meeting_status === 'Planlandı' 
                    ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300'
                    : selectedMeetingDetail.meeting_status === 'Tamamlandı'
                    ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300'
                    : selectedMeetingDetail.meeting_status === 'İptal'
                    ? 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300'
                    : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300'
                }`}>
                  {selectedMeetingDetail.meeting_status}
                </span>
              </div>

              {/* Katılımcılar */}
              {selectedMeetingDetail.meeting_participation && (() => {
                try {
                  const participants = JSON.parse(selectedMeetingDetail.meeting_participation);
                  return participants.length > 0 ? (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Katılımcılar
                      </label>
                      <div className="flex flex-wrap gap-2">
                        {participants.map((participant, index) => (
                          <span 
                            key={index}
                            className="inline-flex items-center px-3 py-1 rounded-full bg-blue-100 text-blue-800 text-sm font-medium"
                          >
                            {participant.user_fullname}
                          </span>
                        ))}
                      </div>
                    </div>
                  ) : null;
                } catch (error) {
                  return null;
                }
              })()}
            </div>

            <div className="flex justify-end p-6 border-t border-gray-200 dark:border-gray-700">
              <button
                onClick={closeMeetingDetailModal}
                className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toplantı durumu değiştirme modal'ı */}
      {showStatusModal && (
        <div className="modal-overlay">
          <div className="modal-content max-w-md">
            <div className="modal-header">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-medium text-white">
                  Toplantı Durumu Değiştir
                </h3>
                <button
                  onClick={() => setShowStatusModal(false)}
                  className="text-white hover:text-gray-300"
                >
                  <FiX size={20} />
                </button>
              </div>
            </div>

            <div className="p-6">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Yeni Durum
                </label>
                <select
                  value={newStatus}
                  onChange={(e) => setNewStatus(e.target.value)}
                  className="input-field"
                >
                  <option value="Planlandı">Planlandı</option>
                  <option value="Tamamlandı">Tamamlandı</option>
                  <option value="İptal">İptal</option>
                  <option value="Ertelendi">Ertelendi</option>
                </select>
              </div>

              {(newStatus === 'İptal' || newStatus === 'Ertelendi') && (
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Açıklama <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    value={statusDescription}
                    onChange={(e) => setStatusDescription(e.target.value)}
                    className="input-field"
                    rows={3}
                    placeholder="Durum değişikliği için açıklama giriniz..."
                    required
                  />
                </div>
              )}

              <div className="flex items-center justify-end space-x-3 pt-6">
                <button
                  onClick={() => setShowStatusModal(false)}
                  className="btn-secondary"
                  disabled={updateMeetingStatusMutation.isLoading}
                >
                  İptal
                </button>
                <button
                  onClick={handleUpdateStatus}
                  disabled={updateMeetingStatusMutation.isLoading}
                  className="btn-primary"
                >
                  {updateMeetingStatusMutation.isLoading ? 'Güncelleniyor...' : 'Güncelle'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      {/* Yeni Teklif Modal */}
      {showOfferModal && (
        <div className="modal-overlay">
          <div className="modal-content max-w-lg">
            <div className="modal-header">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-medium text-white">{editingOffer ? 'Teklifi Düzenle' : 'Yeni Teklif'}</h3>
                <button onClick={() => setShowOfferModal(false)} className="text-white hover:text-gray-300">
                  <FiX size={20} />
                </button>
              </div>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Durum</label>
                  <select
                    className="input-field w-full"
                    value={offerStatus}
                    onChange={(e) => setOfferStatus(e.target.value)}
                  >
                    <option>Hazırlandı</option>
                    <option>Gönderildi</option>
                    <option>Müşteri Onay Sürecinde</option>
                    <option>Müşteri Revize İstedi</option>
                    <option>Teklif Kabul Edilmedi</option>
                    <option>Teklif Onaylandı</option>
                    <option>Revize Gönderilecek</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Para Birimi</label>
                  <select
                    className="input-field w-full"
                    value={offerCurrency}
                    onChange={(e) => setOfferCurrency(e.target.value)}
                  >
                    <option value="TRY">TRY</option>
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Teklif Tutarı</label>
                  <CurrencyInput
                    id="offerTotal"
                    name="offerTotal"
                    placeholder="0.00"
                    value={offerTotal}
                    onValueChange={(value, name) => {
                      setOfferTotal(value);
                    }}
                    prefix={offerCurrency === 'USD' ? '$' : offerCurrency === 'EUR' ? '€' : '₺'}
                    decimalsLimit={2}
                    className="input-field w-full"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Kârlılık</label>
                  <CurrencyInput
                    id="profitability"
                    name="profitability"
                    placeholder="0.00"
                    value={offerProfitability}
                    onValueChange={(value, name) => {
                      setOfferProfitability(value);
                    }}
                    prefix={offerCurrency === 'USD' ? '$' : offerCurrency === 'EUR' ? '€' : '₺'}
                    decimalsLimit={2}
                    className="input-field w-full"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Gönderilme Tarihi</label>
                  <input
                    type="date"
                    value={offerDate}
                    onChange={(e) => setOfferDate(e.target.value)}
                    className="input-field w-full"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Gönderilme Saati</label>
                  <input
                    type="time"
                    value={offerTime}
                    onChange={(e) => setOfferTime(e.target.value)}
                    className="input-field w-full"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Teklif Dosyası (Opsiyonel)</label>
                  <input
                    type="file"
                    onChange={(e) => setOfferFile(e.target.files[0])}
                    className="input-field w-full"
                    accept=".pdf,.doc,.docx,.xls,.xlsx"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Açıklama</label>
                  <textarea
                    value={offerDescription}
                    onChange={(e) => setOfferDescription(e.target.value)}
                    className="input-field w-full"
                    rows={3}
                    placeholder="Teklif açıklaması (opsiyonel)"
                  />
                </div>
              </div>
              {uploadMessage && (
                <div className={`p-3 rounded-md ${uploadMessageType === 'error' ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'}`}>
                  {uploadMessage}
                </div>
              )}
              <div className="flex items-center justify-end space-x-3 pt-6">
                <button
                  onClick={() => setShowOfferModal(false)}
                  className="btn-secondary"
                  disabled={isUploading}
                >
                  İptal
                </button>
                <button
                  onClick={editingOffer ? handleUpdateOffer : handleOfferSubmit}
                  disabled={isUploading}
                  className="btn-primary"
                >
                  {isUploading ? 'Yükleniyor...' : editingOffer ? 'Güncelle' : 'Kaydet'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Teklif Durumu Değiştir Modal */}
      {offerStatusModal.visible && (
        <div className="modal-overlay">
          <div className="modal-content max-w-md">
            <div className="modal-header">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-medium text-white">Teklif Durumu Değiştir</h3>
                <button onClick={() => setOfferStatusModal({ visible: false, offerId: null, status: 'Hazırlandı' })} className="text-white hover:text-gray-300">
                  <FiX size={20} />
                </button>
              </div>
            </div>
            <div className="p-6">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Yeni Durum</label>
                <select
                  value={offerStatusModal.status}
                  onChange={(e) => setOfferStatusModal({ ...offerStatusModal, status: e.target.value })}
                  className="input-field"
                >
                  <option>Hazırlandı</option>
                  <option>Gönderildi</option>
                  <option>Müşteri Onay Sürecinde</option>
                  <option>Müşteri Revize İstedi</option>
                  <option>Teklif Kabul Edilmedi</option>
                  <option>Teklif Onaylandı</option>
                  <option>Revize Gönderilecek</option>
                </select>
              </div>
              <div className="flex items-center justify-end space-x-3 pt-6">
                <button
                  onClick={() => setOfferStatusModal({ visible: false, offerId: null, status: 'Hazırlandı' })}
                  className="btn-secondary"
                >
                  İptal
                </button>
                <button
                  onClick={async () => {
                    try {
                      await customerService.updateCustomerOfferStatus(offerStatusModal.offerId, offerStatusModal.status);
                      toast.success('Teklif durumu güncellendi');
                      setOfferStatusModal({ visible: false, offerId: null, status: 'Hazırlandı' });
                      queryClient.invalidateQueries(['customer-offers', id]);
                    } catch (error) {
                      toast.error('Durum güncellenemedi');
                    }
                  }}
                  className="btn-primary"
                >
                  Güncelle
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Silme Onay Modal */}
      {showConfirmModal && (
        <div className="modal-overlay">
          <div className="modal-content max-w-md">
            <div className="modal-header">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-medium text-white">Silme Onayı</h3>
                <button onClick={() => setShowConfirmModal(false)} className="text-white hover:text-gray-300">
                  <FiX size={20} />
                </button>
              </div>
            </div>
            <div className="p-6">
              <p className="text-sm text-gray-700 dark:text-gray-300">{confirmData.title || 'Bu öğeyi silmek istiyor musunuz?'}</p>
              <div className="flex items-center justify-end space-x-3 pt-6">
                <button onClick={() => setShowConfirmModal(false)} className="btn-secondary">İptal</button>
                <button onClick={handleConfirmDelete} className="btn-danger">Evet, Sil</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerDetail;
